import ArticleLayout from './ArticleLayout'
import { acompanhamentoSeo } from './seo/learningPages'
import { bookingLabel, conversaPath, individualBookingUrl, valoresPath } from './siteDestinations'
import { ArticleCard, ArticleCards, ArticleClosing, ArticleFaq, ArticleList, ArticleSection, ArticleSteps } from './ui/Article'

export default function AcompanhamentoPage() {
  return <ArticleLayout
    eyebrow="Acompanhamento individual · online"
    title={<>A gente faz junto <em>até você seguir sozinho.</em></>}
    intro="Encontros comigo, na sua tela e nas tarefas que você já faz. São 9 horas de acompanhamento pago, de 1 a 2 horas por semana, conforme a sua agenda. Tudo começa com uma conversa gratuita."
    rogerio={{ pose: 'pedindo-esclarecimento', text: 'Um fio de cada vez. A mesa vai ficando sua.' }}
    facts={[[ '9 h', 'de acompanhamento pago' ], [ '1 a 2 h', 'por semana, conforme a sua agenda' ], [ 'Individual', 'com Arthur, por videochamada' ], [ 'WhatsApp', 'dúvidas entre os encontros' ]]}
    flow={['conversar', 'escolher uma tarefa', 'fazer junto', 'conferir', 'tentar sozinho', 'tirar dúvidas', 'retomar']}
    secondary={{ href: '#acompanhamento-momentos', label: 'Ver como funciona' }}
  >
    <ArticleSection id="acompanhamento-momentos" eyebrow="Os três momentos" title="Aprenda fazendo. No seu ritmo.">
      <ArticleSteps steps={[
        { title: 'Conversa: você me conta o que faz.', body: 'São 30 minutos gratuitos, antes das 9 horas pagas. Eu mostro onde a IA entra no seu caso. Você sai com um primeiro passo e decide se quer continuar.' },
        { title: 'A primeira tarefa: a gente faz junto.', body: 'Nos encontros pagos, pegamos uma tarefa sua. Você aprende a pedir, em português, a ajustar o resultado e a conferir. O que a gente faz fica no seu computador.' },
        { title: 'Seguir sozinho: você continua, eu acompanho.', body: 'Entre os encontros, você tenta e pode tirar dúvidas comigo pelo WhatsApp. Na chamada seguinte, a gente parte de onde você chegou, com espaço para novas ideias.' },
      ]} />
    </ArticleSection>
    <ArticleSection id="acompanhamento-agenda" title="Como as horas entram na sua semana">
      <p>Os encontros são individuais, online e por videochamada, no seu computador. As 9 horas pagas são distribuídas de 1 a 2 horas por semana; os horários e a distribuição são combinados conforme a sua agenda.</p>
      <p>As tarefas e o tempo de cada momento dependem do que você trouxer. O objetivo é aprender a fazer, conferir e retomar, com autonomia crescente.</p>
    </ArticleSection>
    <ArticleSection id="acompanhamento-incluido" title="O que está incluído — e o que fica por sua conta">
      <ArticleCards>
        <ArticleCard tone="sage" title="Você conta comigo para">
          <ArticleList>
            <li>9 horas de encontros individuais por videochamada.</li>
            <li>Orientação nas suas tarefas e na escolha das ferramentas.</li>
            <li>Dúvidas pelo WhatsApp entre os encontros.</li>
            <li>Guardar e retomar o que fizermos no seu computador.</li>
            <li>Ficar com qualquer material que eu enviar: ele é seu.</li>
          </ArticleList>
        </ArticleCard>
        <ArticleCard tone="sky" title="Para combinar com clareza">
          <ArticleList>
            <li>As aulas não são gravadas. São transcritas somente com a permissão do participante.</li>
            <li>Assinaturas de ferramentas são por conta do participante e não entram no valor do acompanhamento.</li>
            <li>Você participa das tarefas e confere o que a IA produz. O acompanhamento é para aprender fazendo.</li>
            <li>Você precisa de computador e internet para os encontros.</li>
          </ArticleList>
        </ArticleCard>
      </ArticleCards>
    </ArticleSection>
    <ArticleSection id="acompanhamento-valor" title="O valor é combinado na conversa.">
      <p>Primeiro a gente entende o seu caso. Você conhece o valor e a distribuição das horas antes de decidir continuar.</p>
      <p><a href={valoresPath}>Veja as informações sobre valores →</a></p>
    </ArticleSection>
    <ArticleSection id="acompanhamento-duvidas" title="Antes de decidir">
      <ArticleFaq idPrefix="acompanhamento-faq" items={acompanhamentoSeo.faq} />
    </ArticleSection>
    <ArticleClosing eyebrow="O primeiro passo é gratuito" title="Vamos olhar para o seu caso?" action={{ href: individualBookingUrl, label: bookingLabel, external: true }} secondary={{ href: conversaPath, label: 'Como é a primeira conversa' }} rogerio={{ pose: 'concluido', text: 'Eu cuido do novelo. A conversa é com o Arthur.' }}>
      Você me conta o que faz no computador. Em 30 minutos, a gente encontra um primeiro passo para você tentar sozinho. Continuar comigo é uma escolha sua.
    </ArticleClosing>
  </ArticleLayout>
}
